"use strict";

var parseProductType = require('./parseProductType');

var applyProductProperties = require('./applyProductProperties');

var applyComponentProperties = require('./applyComponentProperties');

function convertFromVersionZero(instance, params) {
  var product_type = parseProductType(params);
  var product = instance.make({
    product_type: product_type
  });
  applyProductProperties.call(product, params, instance);

  if (applyComponentProperties[product.type]) {
    applyComponentProperties[product.type].call(product, params, instance);
  } else {
    throw new Error("applyComponentProperties[".concat(product.type, "] was undefined"));
  }

  if (Object.prototype.hasOwnProperty.call(product, 'ink_colors') && product.ink_colors == null) {
    product.ink_colors = ['Black'];
  }

  return product;
}

module.exports = convertFromVersionZero;